import { createSelector } from '@reduxjs/toolkit';
import { selectDynamicTranslationsLanguage } from 'features/i18n/DynamicTranslation/store/dynamicTranslationSelectors';
import type { DeviceInfo, ProseInfo } from './systemInfoSlice';
import type { RootState } from 'features/store/store';

export const selectIsSystemInfoReady = (state: RootState) =>
  state.systemInfo.isReady;
export const selectBrowserInfo = (state: RootState) => state.systemInfo.browser;

export const selectDeviceInfo = (state: RootState): DeviceInfo => {
  const value = state.systemInfo.device;
  if (!value) {
    throw new Error(
      '[Assert failed] Attempt to rely on device info but it is not available in store'
    );
  }
  return value;
};

export const selectProseInfo = (state: RootState): ProseInfo => {
  const value = state.systemInfo.prose;
  if (!value) {
    throw new Error(
      '[Assert failed] Attempt to rely on PROSE info but it is not available in store'
    );
  }
  return value;
};

export const selectWindowId = (state: RootState): string => {
  const value = state.systemInfo.windowId;
  if (!value) {
    throw new Error(
      '[Assert failed] Attempt to rely on windowId but it is not available in store'
    );
  }
  return value;
};

export const selectTraceInfo = createSelector(
  selectWindowId,
  selectProseInfo,
  selectBrowserInfo,
  selectDeviceInfo,
  selectDynamicTranslationsLanguage,
  (windowId, proseInfo, browserInfo, deviceInfo, language) => ({
    windowId,
    proseInfo,
    browserInfo,
    deviceInfo,
    language,
  })
);
